class HeaderNavigation {
  nav: HTMLElement | null;
  next: HTMLElement | null;
  lastScroll: number;

  constructor() {
    this.nav = document.querySelector(".header-navigation");
    this.next = document.querySelector(".main");
    this.lastScroll = window.pageYOffset;

    if (this.nav && this.next) {
      this.init();
    }
  }

  init() {
    this.initScrollListener();
    this.updatePadding();
  }

  updatePadding() {
    const navHeight = this.nav!.offsetHeight;
    this.next!.style.paddingTop = `${navHeight}px`;
  }

initScrollListener() {
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    const navHeight = this.nav!.offsetHeight;

    if (currentScroll <= navHeight) {
      this.nav!.classList.remove('hide');
    } else if (currentScroll > this.lastScroll) {
      this.nav!.classList.add('hide');
    } else {
      this.nav!.classList.remove('hide');
    }

    this.lastScroll = currentScroll;
  });
}
}

export const headerNavigation = new HeaderNavigation();
